import React from 'react';
import Head from 'next/head';

export const MixiDesktop = () => {
  return (
    <>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function() {
                var sc = document.createElement('script'); sc.type = 'text/javascript'; sc.async = true;
                sc.src = '//mixi.media/data/js/98167.js'; sc.charset = 'utf-8';
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(sc, s);
              }());
            `,
          }}
          defer
          key="MixiDesktop"
          type="text/javascript"
        />
      </Head>
      <div id="unit_98167">
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <a href="https://mixi.media/" rel="nofollow"></a>
      </div>
    </>
  );
};

export default MixiDesktop;
